import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { label: "Support", to: "/support" },
  { label: "Pricing", to: "/pricing" },
  { label: "About & Legal", to: "/about" },
  { label: "SMS Consent", to: "/sms-consent" },
];

export const Footer = () => {
  const { pathname } = useLocation();
  const dark = ["/pricing"].includes(pathname);
  return (
    <footer
      data-testid="app-footer"
      className={
        dark
          ? "border-t border-white/10 bg-[#070d1c] text-slate-400"
          : "border-t border-[var(--line)] bg-white text-[var(--text-2)]"
      }
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-serif text-lg tracking-tight text-current">
          ReMind Me <span className="italic">&amp; Do</span>
        </p>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={
                dark
                  ? "text-sm hover:text-emerald-300 transition-colors"
                  : "text-sm hover:text-[var(--accent)] transition-colors"
              }
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="text-xs opacity-70">© {new Date().getFullYear()} ReMind Me &amp; Do</p>
      </div>
    </footer>
  );
};
